import { Injectable } from '@angular/core';
import { AngularFireDatabaseWrapper } from '../../../providers/angularfire-wrapper';

@Injectable()
export class ServicesData {

    constructor(
        public afw: AngularFireDatabaseWrapper 
        ) {
    }

    
}


// WEBPACK FOOTER //
// ./src/modules/services/providers/services-data.ts